import { getDateRangeISOString } from 'hybridspace-common/lib/utils/getDateRangeISOString';
import { createObservableOperation } from 'owa-observable-operation';
import { getPlacesWorkLocationInfo } from '../services/getPlacesWorkLocationInfo';

import type { DateRange } from 'owa-datetime-utils';
import type { TraceErrorObject } from 'owa-analytics-types';
import type { WorkLocationInfo } from '../operationTypes';

const dest = createObservableOperation(
    'PLACES_LOAD_WORK_LOCATION_INFO',
    (
        dateRange: DateRange,
        isRetry?: boolean
    ): {
        dateRange: DateRange;
        isRetry: boolean | undefined;
    } => ({ dateRange, isRetry }),
    ({ dateRange }) => getDateRangeISOString(dateRange),
    ({ dateRange, isRetry }) => getPlacesWorkLocationInfo(dateRange, isRetry)
);
const loadWorkLocationInfo: (
    dateRange: DateRange,
    isRetry?: boolean
) => {
    dateRange: DateRange;
    isRetry: boolean | undefined;
} = dest.start;
const loadWorkLocationInfoSucceeded: (
    actionMessage: {
        dateRange: DateRange;
        isRetry: boolean | undefined;
    } & {
        result: WorkLocationInfo;
    }
) => {
    dateRange: DateRange;
    isRetry: boolean | undefined;
} & {
    result: WorkLocationInfo;
} = dest.onSucceeded;
const loadWorkLocationInfoEnded: (actionMessage: {
    dateRange: DateRange;
    isRetry: boolean | undefined;
}) => {
    dateRange: DateRange;
    isRetry: boolean | undefined;
} = dest.onEnded;
const loadWorkLocationInfoAsync: (
    dateRange: DateRange,
    isRetry?: boolean | undefined
) => Promise<WorkLocationInfo> = dest.startAsync;
const loadWorkLocationInfoInProgress: (key: string) => boolean = dest.isInProgress;
const getWorkLocationInfoLastError: (key: string) => TraceErrorObject | undefined =
    dest.getLastError;

export {
    loadWorkLocationInfo,
    loadWorkLocationInfoEnded,
    loadWorkLocationInfoSucceeded,
    loadWorkLocationInfoAsync,
    loadWorkLocationInfoInProgress,
    getWorkLocationInfoLastError,
};
